import { inject, NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { HomeComponent } from '../components/home/home.component';
import { BulkUploadComponent } from '../components/bulk-upload/bulk-upload.component';
import { ProfileComponent } from 'accounts';
import { AuthGuardService, UnauthorisedComponent } from 'common';
import { SignupComponent } from '../components/signup/signup.component';
import { SignupLookupsResolver } from '../resolvers/signup-lookups.resolver';
import { NotFoundComponent } from '../components/not-found/not-found.component';
import { PublicSenderIdSearchComponent } from '../components/public-sender-id-search/public-sender-id-search.component';
import { PublicAuthorisedPaSearchComponent } from '../components/public-authorised-pa-search/public-authorised-pa-search.component';
import { PublicAuthorisedPaListResolver } from '../resolvers/public-authorised-pa-list.resolver';

const routes: Routes = [
  { path: '', component: HomeComponent },
  { path: '404', component: NotFoundComponent },
  { path: 'profile', component: ProfileComponent, canActivate: [AuthGuardService], outlet: 'profilePopup' },
  { path: 'sender-id-sign-up', component: SignupComponent, resolve: { lookups: SignupLookupsResolver } },
  { path: 'accounts', loadChildren: () => import('accounts').then((m) => m.AccountsModule) },
  { path: 'bulk-upload', component: BulkUploadComponent },
  { path: 'registrations', loadChildren: () => import('../modules/registrations.module').then(m => m.RegistrationsModule) },
  { path: 'sender-ids', loadChildren: () => import('../modules/sender-ids.module').then(m => m.SenderIdsModule) },
  { path: 'opas', loadChildren: () => import('../modules/opas.module').then(m => m.OpasModule) },
  { path: 'sender-id-search', component: PublicSenderIdSearchComponent },
  { path: 'authorised-pa-search', component: PublicAuthorisedPaSearchComponent, resolve: { pa: PublicAuthorisedPaListResolver } },
  { path: 'unauthorised', component: UnauthorisedComponent, pathMatch: 'full' },
  { path: '**', redirectTo: '/404', pathMatch: 'full' },
];

@NgModule({
  declarations: [],
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {
  constructor() {
  }
}

